import { UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../generic-button/button.component';

@Component({
  selector: 'lib-grid-reset-header',
  templateUrl: './ag-grid-reset-header.component.html',
  styleUrls: ['./ag-grid-reset-header.component.scss'],
  imports: [ButtonComponent, TranslateModule, UpperCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgGridResetHeaderComponent implements OnDestroy {
  params: any;
  isDisabled = signal(true);
  showLabel = signal(true);

  private readonly onFilterOrSortChanged = (): void => this.updateButtonState();

  agInit(params: any): void {
    this.params = params;
    if (params.showLabel !== undefined) {
      this.showLabel.set(params.showLabel);
    }
    this.updateButtonState();

    this.params.api.addEventListener(
      'filterChanged',
      this.onFilterOrSortChanged
    );
    this.params.api.addEventListener('sortChanged', this.onFilterOrSortChanged);
  }

  ngOnDestroy(): void {
    this.params?.api?.removeEventListener(
      'filterChanged',
      this.onFilterOrSortChanged
    );
    this.params?.api?.removeEventListener(
      'sortChanged',
      this.onFilterOrSortChanged
    );
  }

  resetColumns() {
    const api = this.params.api;

    // Clears the model + checkbox selections and re-runs filtering
    api.setFilterModel(null);

    api
      .getColumns()
      ?.forEach((col: { getColId: () => string }) =>
        api.destroyFilter(col.getColId())
      );

    api.applyColumnState({
      defaultState: { sort: null },
    });
  }

  updateButtonState() {
    const api = this.params.api;
    const hasFilter =
      api.getFilterModel() && Object.keys(api.getFilterModel()).length > 0;
    const hasSorting = api
      .getColumnState()
      .some((col: { sort: null }) => col.sort != null);

    this.isDisabled.set(!(hasFilter || hasSorting));
  }
}
